import { useCallback } from 'react';
import { useMutationLogout, useRefreshUser } from '../data';
import { useSavedLocation } from '../use-saved-location';
import { InactiveModal } from './InactiveModal';
export function IdleTimeout() {
  const refreshUser = useRefreshUser();
  const {
    mutate: logout
  } = useMutationLogout();
  useSavedLocation();
  const refreshSession = useCallback(async () => {
    const session = await refreshUser();
    return session.data ?? null;
  }, [refreshUser]);
  return <InactiveModal logout={noReturn => logout({
    noReturn
  })} refreshSession={refreshSession} />;
}